import { isAfter, isValid } from 'date-fns';
import { toast } from 'react-toastify';

// Os filtros por período precisam das duas datas: a API só filtra quando recebe as duas e,
// se falta uma, devolve tudo sem aviso.
export function dateRangeError(initial: Date | null | undefined, final: Date | null | undefined): string {
  if (!initial || !final || !isValid(initial) || !isValid(final)) return 'Informe as datas inicial e final.';
  if (isAfter(initial, final)) return 'A data inicial não pode ser maior que a data final.';

  return '';
}

// Avisa na tela e devolve false quando o período não pode ser buscado; quando devolve true, as duas datas existem.
export function checkDateRange<T extends { initial_date: Date | null; final_date: Date | null }>(
  range: T,
): range is T & { initial_date: Date; final_date: Date } {
  const message = dateRangeError(range.initial_date, range.final_date);
  if (message) toast.warning(message);

  return !message;
}
